export default __webpack_public_path__ + "static/media/oneIcon.59265be5.svg";